// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleImage_container__iNqaP"};